<h2 *ngIf="!!data.title" mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content *ngIf="data.text" [innerHTML]="data.text"></mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ data.cancelButton }}</button>
  <button *ngIf="data.positiveButton" mat-flat-button color="primary"
          (click)="onPositive()">{{ data.positiveButton }}</button>
</mat-dialog-actions>
